<template>
  <p
    v-show="show"
    class="VueTextToSpeech-Message"
    v-html="message"
    role="text"
  ></p>
</template>

<script>
export default {
  name: 'TextToSpeechMessage',
  inject: ['tts'],
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ttsMessage: null,
      elementClone: null,
    };
  },
  mounted() {
    if (this.show) {
      this.$el.setAttribute('tabindex', '0');
      this.$el.setAttribute('aria-label', this.ttsMessage);
      this.$el.setAttribute('role', 'text');
    }

    this.elementClone = this.$el.cloneNode();
    this.elementClone.classList.add('comet-screenreader-only');
    this.elementClone.classList.add('vue-text-to-speech-message-hidden');
    this.elementClone.removeAttribute('aria-label');
    this.elementClone.removeAttribute('tabindex');
    this.elementClone.removeAttribute('style');
    this.elementClone.innerHTML = this.ttsMessage;

    document.querySelector('body').appendChild(this.elementClone);

    this.tts.$on('onPlay', () => {
      this.tts.textToSpeech.View.play(this.elementClone);
    });
  },
  watch: {
    message: {
      immediate: true,
      handler: function (value) {
        if (value) {
          /* commenting out this line below to avoid the automatic pause on tts when changing text */
          // this.tts.stop();
          this.ttsMessage = value.replace(/<[^>]*>?/gm, ' ').trim();
        }
      },
    },
    ttsMessage: {
      immediate: true,
      handler: function (value) {
        if (value && this.elementClone) {
          this.elementClone.innerHTML = value;
        }
      },
    },
  },
  destroyed() {
    if (this.elementClone) {
      this.tts.stop();
      this.tts.$off('onPlay');
      document.querySelector(`body`).removeChild(this.elementClone);
    }
  },
};
</script>

<style lang="stylus" scoped>
.VueTextToSpeech-Message
  white-space pre-line
  margin 0

.vue-text-to-speech-message-hidden
  width 50%
  margin -1px
  padding 0
  font-size 1px
</style>
